import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as fromLaunchContext from "./launch-context.reducer";

// this is the type for our assignables.module
// this creates the structure for our state tree
export interface LaunchState {
    launchContext: fromLaunchContext.LaunchContextState;
}

// register the reducers
// a slice of state is managed by a reducer function
// ** Remember a reducer is a pure function
// this can be type check with ActionReducerMap as type LaunchState
export const reducers: ActionReducerMap<LaunchState> = {
    launchContext: fromLaunchContext.reducer
};

// This const creates the base level of our state object
// A reference to our launch context State
// and will hold a selector for the entire lazy-loaded module
export const getLaunchContextState = createFeatureSelector<LaunchState>("launchContext");
